/*
 * @Description: 客户案例页面所有路由
 * @Author: mike ma *
 * @Date: 2021-02-24 16:50:00
 * @LastEditTime: 2021-02-27 20:12:42
*/

export default [
    {
        path: 'customer',
        component: resolve => require(['@/views/customer'], resolve),
        name: 'Customer',
        meta: {
            nav: '客户案例'
        }
    }
      
]


// WEBPACK FOOTER //
// ./src/router/customer.js